import { render, staticRenderFns } from "./AddManualPayment.vue?vue&type=template&id=3da3dc88&"
import script from "./AddManualPayment.vue?vue&type=script&lang=js&"
export * from "./AddManualPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports